import { type ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { PREMIUM_GATING_ENABLED } from "@/config/premium";
import { usePremium } from "@/hooks/usePremium";
import { Paywall } from "@/components/Paywall";
import Navigation from "@/components/Navigation";

function EnabledPremiumRoute({ children }: { children: ReactNode }) {
  const { isPremium, periodEnd, loading, userId } = usePremium();
  if (loading) return <div className="min-h-screen flex items-center justify-center"><div className="h-8 w-8 animate-spin rounded-full border-4 border-primary border-t-transparent" /></div>;
  if (!userId) return <Navigate to="/auth" replace />;
  if (!isPremium) return <><Navigation /><Paywall periodEnd={periodEnd} /></>;
  return <>{children}</>;
}

export function PremiumRoute({ children }: { children: ReactNode }) {
  if (!PREMIUM_GATING_ENABLED) return <>{children}</>;
  return <EnabledPremiumRoute>{children}</EnabledPremiumRoute>;
}